import { useState, useRef, useEffect, useContext } from "react";
import { getServicesByGroups } from "../api/servicesApi";
import { getbarbers, getAvailableTimeSlots } from "../api/barberApi";
import { getBarberUnavailabilities } from "../api/barberUnavailabiltyApi";
import { comfirmBooking } from "../api/bookingApi";
import { data, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { BarbershopContext } from "../providers/useProvider";
import { useAuthState } from "../providers/AuthStateProvider";

const useAppointment = () => {
  const [step, setStep] = useState(1);
  const [disableNext, setDisableNext] = useState(false);

  const [services, setServices] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [availableStaffList, setAvailableStaffList] = useState([]);
  const navigate = useNavigate();
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedTime, setSelectedTime] = useState(null);
  const [unavailability, setUnavailability] = useState([]);
  const [availableTimes, setAvailableTimes] = useState([]);

  const { shopClosedDays, shopClosedWeekDays, config } =
    useContext(BarbershopContext);
  const { user, setUser } = useAuthState();
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("main-page")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 50);
  }, [step]);
  useEffect(() => {
    if (config?.id) {
      getServicesByGroups(config.id).then(setServices);
      getbarbers(config.id).then(setStaffList);
    }
  }, [config]);
  useEffect(() => {
    if (selectedServices) {
      const barberIds =
        selectedServices.length === 0
          ? []
          : selectedServices
              .map((s) => s.barberServices.map((bs) => bs.barberId))
              .reduce((acc, ids) => acc.filter((id) => ids.includes(id)));

      setAvailableStaffList(barberIds);
      clearTimeAndList();
    }
  }, [selectedServices]);
  useEffect(() => {
    btnNextEnabled();
  }, [selectedServices, selectedStaff, selectedDate, selectedTime, step]);

  useEffect(() => {
    if (selectedStaff) {
      const normalizedIds = availableStaffList.map((id) => id.toLowerCase());
      const isDisabled = !normalizedIds.includes(
        selectedStaff.id.toLowerCase(),
      );
      if (isDisabled) {
        setSelectedStaff(null);
      } else {
        clearTimeAndList();
        getBarberUnavailabilities(selectedStaff.id).then(setUnavailability);
      }
    }
  }, [selectedStaff]);
  const clearTimeAndList = () => {
    setAvailableTimes([]);
    setSelectedTime(null);
  };
  useEffect(() => {
    let today = new Date();
    if (unavailability.length > 0) {
      while (1) {
        const isClosedWeekday = shopClosedWeekDays.includes(today.getDay());
        const isSpecialClosed = shopClosedDays.some(
          (d) => new Date(d.date).toDateString() === today.toDateString(),
        );
        const isUnAvailable = unavailability.some(
          (d) =>
            new Date(d.date).toDateString() === today.toDateString() &&
            d.startTime == null &&
            d.endTime == null,
        );
        if (isClosedWeekday || isSpecialClosed || isUnAvailable) {
          today.setDate(today.getDate() + 1);
        } else {
          break;
        }
      }
    }
    setSelectedDate(today);
  }, [unavailability]);

  useEffect(() => {
    const fetchAvailability = async () => {
      if (
        !selectedStaff?.id ||
        !config?.id ||
        !selectedDate ||
        selectedServices.length === 0
      )
        return;

      try {
        const totalDuration = selectedServices.reduce((acc, service) => {
          const barberSpecific = service.barberServices.find(
            (bs) =>
              bs.barberId.toLowerCase() === selectedStaff.id.toLowerCase(),
          );
          return acc + (barberSpecific?.time || 0);
        }, 0);

        setSelectedTime(null);
        const timeSlots = await getAvailableTimeSlots(
          selectedStaff.id,
          config.id,
          selectedDate,
          totalDuration,
        );
        if (timeSlots.length > 0) {
          const formatted = timeSlots.map((time) =>
            time.split(":").slice(0, 2).join(":"),
          );
          setAvailableTimes(formatted || []);
        } else {
          setAvailableTimes([]);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchAvailability();
  }, [selectedDate, selectedServices, selectedStaff]);

  const btnNextEnabled = () => {
    switch (step) {
      case 1:
        if (selectedServices.length > 0) {
          setDisableNext(false);
        } else {
          setDisableNext(true);
        }
        break;
      case 2:
        if (selectedStaff) {
          setDisableNext(false);
        } else {
          setDisableNext(true);
        }
        break;
      case 3:
        if (selectedTime) {
          setDisableNext(false);
        } else {
          setDisableNext(true);
        }
        break;
      case 4:
        setDisableNext(true);
        break;
    }
    if (step === 1) {
    }
  };
  // Add/remove a service
  const onToggleService = (service) => {
    setSelectedServices((prev) => {
      const exists = prev.find((s) => s.id === service.id);
      return exists
        ? prev.filter((s) => s.id !== service.id)
        : [...prev, { ...service, quantity: 1 }];
    });
  };
  const handleQuantityChange = (serviceId, qty) => {
    setSelectedServices((prev) =>
      prev.map((service) =>
        service.id === serviceId ? { ...service, quantity: qty } : service,
      ),
    );
  };

  const onSelectStaff = (staff) => {
    if (staff != selectedStaff) {
      setSelectedStaff(staff);
      let today = new Date();
      setSelectedDate(today);
      setSelectedTime(null);
    }
  };

  const handleConfirmBooking = async () => {
    try {
      // Example list of services with dynamic GUID keys
      const selectedServiceList = selectedServices.map((s) => ({
        id: s.id,
        quantity: s.quantity,
      }));

      // Convert to dictionary-style object expected by .NET
      const servicesDict = {};
      selectedServiceList.forEach((s) => {
        servicesDict[s.id] = s.quantity;
      });
      const appointmentData = {
        staffId: selectedStaff.id,
        services: servicesDict,
        date: selectedDate.toLocaleDateString("sv-SE"),
        time: selectedTime,
      };

      if (!user.token) {
        // Save booking and redirect to login
        // When user confirms services but isn't logged in:
        sessionStorage.setItem(
          "pendingBooking",
          JSON.stringify(appointmentData),
        );
        localStorage.setItem("intendedRoute", "/confirm-booking");
        navigate(`/login`);
      } else {
        // Send booking immediately (you can extract this to a shared function)

        const decoded = jwtDecode(user.token); // Decode JWT token to get user details
        const { exp } = decoded;
        const currentTime = Date.now() / 1000; // in seconds

        if (exp < currentTime) {
          setUser({ token: null, fullName: null });
          localStorage.removeItem("authToken");
          localStorage.removeItem("fullName");
          sessionStorage.setItem(
            "pendingBooking",
            JSON.stringify(appointmentData),
          );
          localStorage.setItem("intendedRoute", "/confirm-booking");
          navigate(`/login`);
        } else {
          var response = await comfirmBooking(appointmentData, config.id);
          if (!response) return;

          navigate(`/${response.data}/appointment-summary`);
        }
      }

      // show success UI
    } catch (err) {
      // show error UI
    }
  };
  const goNext = () => {
    setStep((prev) => prev + 1);
  };
  const goBack = () => setStep((prev) => prev - 1);
  return {
    step,
    setStep,
    disableNext,
    services,
    selectedServices,
    availableStaffList,
    onToggleService,
    staffList,
    selectedStaff,
    onSelectStaff,
    selectedDate,
    setSelectedDate,
    selectedTime,
    setSelectedTime,
    availableTimes,
    unavailability,
    shopClosedDays,
    shopClosedWeekDays,
    handleConfirmBooking,
    handleQuantityChange,
    goNext,
    goBack,
  };
};
export default useAppointment;
